import { euros } from '../lib/format';

export interface Chiffre {
  libelle: string;
  valeur: string;
  aide?: string;
}

/** Grille de chiffres clés, compacte pour une barre latérale étroite. */
export function Chiffres({ elements }: { elements: Chiffre[] }) {
  return (
    <dl className="chiffres">
      {elements.map((element) => (
        <div key={element.libelle} className="chiffre" title={element.aide}>
          <dt>{element.libelle}</dt>
          <dd>{element.valeur}</dd>
        </div>
      ))}
    </dl>
  );
}

/**
 * Les trois montants du contrat, en euros HT.
 * Un zéro est affiché tel quel : « chiffré 0 € » après six mois d'échanges est
 * précisément le signal que le commercial doit voir.
 */
export function chiffresAffaire(source: {
  chiffre_ht: number;
  commande_ht: number;
  facture_ht: number;
}): Chiffre[] {
  return [
    { libelle: 'Chiffré', valeur: euros(source.chiffre_ht), aide: 'Montant chiffré HT' },
    { libelle: 'Commandé', valeur: euros(source.commande_ht), aide: 'Montant commandé HT' },
    { libelle: 'Facturé', valeur: euros(source.facture_ht), aide: 'Montant facturé HT' },
  ];
}
